module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "lxm-item box",
    on: {
      "click": _vm.clicked
    }
  }, [_c('div', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-item has-text-left"
  }, [_c('p', {
    staticClass: "lxm-item__name"
  }, [(_vm.showIcon) ? _c('img', {
    staticClass: "lxm-item__lock",
    attrs: {
      "src": require("../../images/main/lock.png")
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', {
    staticClass: "lxm-item__sub"
  }, [_vm._v(_vm._s(_vm.update))])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('p', {
    staticClass: "lxm-item__value"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('p', {
    staticClass: "lxm-item__sub"
  }, [_vm._v(_vm._s(_vm.valueSuffix))])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f40dcd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f40dcd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmItem.vue
// module id = 865
// module chunks = 0